module.exports = __webpack_public_path__ + "static/media/9.e4573f6f.jpg";